import { Navbar } from "@/projects/FinEaseHome/pages/FinEaseHomePage/Navbar";
import { Footer } from "@/projects/FinEaseHome/pages/FinEaseHomePage/Footer";
import { Hero } from "@/projects/FinEaseHome/pages/FinEaseHomePage/Hero";
import { InvestmentOfferings } from "./InvestmentOfferings";
import { StatsSection } from "./StatsSection";
import { WhyChooseSection } from "./WhyChooseSection";
import { AlternatingFeatures } from "./AlternatingFeatures";
import { CTASection } from "./CTASection";
import { InvestorsDetails } from "./InvestorsDetails";

const FinEaseHomePage = () => {
  return (
    <div className="min-h-screen bg-background font-sans">
      <Navbar />
      <main>
        {/* Hero Section */}
        <Hero />
        {/* Investors Details */}
        <InvestorsDetails />
        {/* Offerings Grid */}
        <InvestmentOfferings />
        {/* Stats Section */}
        <StatsSection />
        {/* Why Choose Section */}
        <WhyChooseSection />
        {/* Alternating Features */}
        <AlternatingFeatures />
        {/* CTA Section */}
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default FinEaseHomePage;
